export default "__VITE_ASSET__74eb2f90__"